const ACTIVITY = [
  { icon: "v2", title: "v2.4 shipped to App Store", meta: "iOS · Android", time: "now" },
  { icon: "↑", title: "Push campaign · 3.2k opened", meta: "Growth", time: "2m" },
  { icon: "N", title: "New workspace: Orbit Pay", meta: "Signup", time: "9m" },
  { icon: "✓", title: "Crash resolved · iOS 17.4", meta: "Stability", time: "14m" },
  { icon: "★", title: "5-star review from Nova Labs", meta: "Store", time: "31m" },
  { icon: "⟳", title: "OTA update rolled to 100%", meta: "Release", time: "1h" },
];

const USERS = ["12.4k", "12.6k", "12.9k", "13.1k"];
const SPARK = [42, 58, 50, 66, 74, 68, 88, 96];

const TABS = [
  {
    label: "Home",
    icon: `<path d="M4 11.5 12 5l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5h-5v5H5a1 1 0 0 1-1-1v-7.5Z" />`,
  },
  {
    label: "Stats",
    icon: `<path d="M5 19V11M12 19V5M19 19v-8" stroke-linecap="round" />`,
  },
  {
    label: "Inbox",
    icon: `<path d="M4 6h16v12H4zM4 7l8 6 8-6" stroke-linejoin="round" />`,
  },
  {
    label: "Team",
    icon: `<circle cx="9" cy="9" r="3" /><circle cx="17" cy="10" r="2.4" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0M14.5 19a4 4 0 0 1 6 0" stroke-linecap="round" />`,
  },
];

function renderRow(item) {
  return `
    <div class="app-phone__row">
      <span class="app-phone__row-icon">${item.icon}</span>
      <span class="app-phone__row-text">
        <strong>${item.title}</strong>
        <small>${item.meta}</small>
      </span>
      <time>${item.time}</time>
    </div>
  `;
}

export function createAppDevelopmentStage() {
  const wrap = document.createElement("div");
  wrap.className = "services-stage services-stage--app reveal";
  wrap.style.setProperty("--delay", "0.18s");
  wrap.setAttribute("aria-hidden", "true");

  wrap.innerHTML = `
    <div class="services-stage__glow services-stage__glow--app"></div>
    <div class="services-stage__orb services-stage__orb--a"></div>
    <div class="services-stage__orb services-stage__orb--b"></div>
    <div class="services-stage__orb services-stage__orb--c"></div>

    <div class="services-stage__window services-stage__panel app-phone">
      <div class="app-phone__screen">
        <span class="app-phone__island"></span>
        <div class="app-phone__status">
          <span>9:41</span>
          <span class="app-phone__status-icons">
            <i></i><i></i><i></i>
            <b></b>
          </span>
        </div>

        <header class="app-phone__header">
          <div>
            <small>Good morning</small>
            <strong>Nova Labs</strong>
          </div>
          <span class="app-phone__avatar">NL</span>
        </header>

        <section class="app-phone__hero">
          <span class="app-phone__eyebrow">Active users</span>
          <strong data-users>${USERS[0]}</strong>
          <small data-users-delta>+8.2% this week</small>
          <div class="app-phone__spark" data-spark>
            ${SPARK.map((h) => `<span style="--h: ${h}%"></span>`).join("")}
          </div>
        </section>

        <div class="app-phone__stats">
          <article class="app-phone__stat">
            <strong data-releases>24</strong>
            <small>Releases</small>
          </article>
          <article class="app-phone__stat">
            <strong>99.8%</strong>
            <small>Crash-free</small>
          </article>
          <article class="app-phone__stat">
            <strong>4.9★</strong>
            <small>Rating</small>
          </article>
        </div>

        <section class="app-phone__list">
          <span class="app-phone__eyebrow">Recent activity</span>
          <div class="app-phone__feed" data-feed></div>
        </section>

        <nav class="app-phone__tabs" data-tabs>
          ${TABS.map(
            (tab, i) => `
            <span class="app-phone__tab${i === 0 ? " is-active" : ""}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">${tab.icon}</svg>
              ${tab.label}
            </span>
          `
          ).join("")}
        </nav>
        <span class="app-phone__home"></span>
      </div>
    </div>
  `;

  bindAppRuntime(wrap);
  return wrap;
}

function bindAppRuntime(root) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const feed = root.querySelector("[data-feed]");
  const users = root.querySelector("[data-users]");
  const releases = root.querySelector("[data-releases]");
  const spark = [...root.querySelectorAll("[data-spark] span")];
  const tabs = [...root.querySelectorAll("[data-tabs] .app-phone__tab")];

  if (!feed) return;

  let step = 0;
  let timer = null;

  const pushRow = () => {
    feed.insertAdjacentHTML("afterbegin", renderRow(ACTIVITY[step % ACTIVITY.length]));
    while (feed.children.length > 3) {
      feed.lastElementChild?.remove();
    }
  };

  const paintSpark = () => {
    const peak = (step + SPARK.length - 1) % SPARK.length;
    spark.forEach((bar, i) => {
      const value = SPARK[(i + step) % SPARK.length];
      bar.style.setProperty("--h", `${value}%`);
      bar.classList.toggle("is-peak", i === peak);
    });
  };

  const tick = () => {
    step += 1;
    pushRow();
    paintSpark();
    if (users) users.textContent = USERS[step % USERS.length];
    if (releases && step % 3 === 0) releases.textContent = String(24 + Math.floor(step / 3));
    tabs.forEach((tab, i) => tab.classList.toggle("is-active", i === step % tabs.length));
  };

  pushRow();
  paintSpark();

  if (reduced) return;

  const start = () => {
    if (timer) return;
    timer = window.setInterval(tick, 2400);
  };

  const stop = () => {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  };

  start();

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) start();
      else stop();
    },
    { threshold: 0.2 }
  );

  observer.observe(root);
}
